import React, {Component} from 'react';
import UserService from "../../apiServices/UserService";
import {Descriptions, Icon, message} from "antd";
import {List, WhiteSpace} from "antd-mobile";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

class User extends Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            changePass: 0,
            changeInfo: 0,
            user: null,
            user_name: '',
            user_phone: null,
            user_email: null
        };
    }

    componentDidMount() {
        let userInfo = JSON.parse(localStorage.getItem('user_info'));
        if (userInfo){
            this.setState({user_name: userInfo.name, user_phone: userInfo.phone, user_email: userInfo.email})
        }else{
            UserService.fetchMe().then(response => {
                this.setState({user_name: response.data.name, user_phone: response.data.phone, user_email: response.data.email})
            });
        }
    }

    logout = () => {
        cookies.remove('access_token', {path: '/'});
        localStorage.clear();
        window.location.reload();
    };

    render() {
        return (
            <div style={{marginTop: '15px'}}>
                <Descriptions title="" size="default" layout="horizontal" column={1}>
                    <Descriptions.Item label="Họ tên">{this.state.user_name}</Descriptions.Item>
                    <Descriptions.Item label="Số điện thoại: ">{this.state.user_phone}</Descriptions.Item>
                    <Descriptions.Item label="Email: ">{this.state.user_email}</Descriptions.Item>
                </Descriptions>
                <WhiteSpace size='xl' />
                <List>
                    <List.Item arrow="horizontal" onClick={() => this.props.history.push('/doi-mat-khau')}>
                        <Icon type="edit" /> Đổi mật khẩu
                    </List.Item>
                    <List.Item onClick={() => {this.props.history.push('/cap-nhat-thong-tin')}} arrow="horizontal">
                        <Icon type="edit" /> Cập nhật thông tin
                    </List.Item>
                    <List.Item onClick={() => {window.location = "tel:0971979784"}}>
                        <Icon type="phone" /> Gọi điện hỗ trợ
                    </List.Item>
                    <List.Item onClick={() => {window.location = "mailto:info@insunow.com"}}>
                        <Icon type="mail" /> Gửi Email hỗ trợ
                    </List.Item>
                    <List.Item onClick={() => {message.error('Tính năng đang hoàn thiện');}}>
                        <Icon type="question-circle" /> Câu hỏi thường gặp
                    </List.Item>
                    <List.Item onClick={() => {this.logout()}}>
                        <Icon type="logout" /> Thoát
                    </List.Item>
                </List>
            </div>
        )
    }
}

export default (User);